import { ImageType } from "../../../types/productTypes";
import NormalGallery from "./NormalGallery";

interface ImageGalleryProps {
   itemPairImages: ImageType[][] | null | undefined;
   stageName: string;
   mainImage: ImageType | undefined;
   productTitle: string;
}

export default function ImageGallery({
   itemPairImages,
   stageName,
   mainImage,
   productTitle,
}: ImageGalleryProps) {
   return (
      <NormalGallery
         mainImage={mainImage}
         itemPairImages={itemPairImages}
         stageName={stageName}
         productTitle={productTitle}
      />
   );
}
